import { render, staticRenderFns } from "./InstructionHtml.vue?vue&type=template&id=8817f392&"
import script from "./InstructionHtml.vue?vue&type=script&lang=js&"
export * from "./InstructionHtml.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports